import { USER_AGREEMENT } from "../../../../common/src";
import { AuthLayout } from "../auth/AuthLayout";
import { AgreementView } from "./AgreementView";

/** The current User Agreement, readable by anyone (linked from the site footer). */
export const PublicAgreementPage = () => (
  <AuthLayout width={760}>
    <AgreementView doc={USER_AGREEMENT} expanded />
    <p>
      <a href="#/">Back to VetBoats</a>
    </p>
  </AuthLayout>
);
